export const SERVICES = [
  {
    slug: "inloopdouche-plaatsen",
    title: "Inloopdouche plaatsen",
    h1: "Inloopdouche plaatsen — vakkundig geïnstalleerd",
    tag: "01 — Inloopdouches",
    image: "/brand/services-v2/inloopdouches.png",
    intro:
      "Een moderne inloopdouche transformeert uw badkamer in een spa-achtige oase. Bij Master-Bathrooms plaatsen wij inloopdouches volledig op maat — met frameless glas, matzwarte regendouches en luxueuze afwerking.",
    sections: [
      {
        h: "Wat we voor u doen",
        p: "Van het weghalen van uw oude bad tot de complete installatie van uw nieuwe inloopdouche. Tegelwerk, waterdichte fundering, loodgieterswerk, matzwarte kranen en glasplaatsing — alles door één team.",
      },
      {
        h: "Materialen & mogelijkheden",
        p: "Frameless of half-frameless glas, mineraal-composiet douchebakken in wit of antraciet, matzwart, chroom of geborsteld messing kraanwerk, regendouches met glijstang, verlichte nissen en vloerverwarming onder de tegels.",
      },
      {
        h: "Doorlooptijd & prijs",
        p: "De meeste inloopdouche-installaties leveren wij binnen enkele werkdagen op. Prijzen bespreken we tijdens het gratis en vrijblijvend adviesgesprek bij u thuis, met een eerlijke prijsopgave op maat.",
      },
    ],
  },
  {
    slug: "badkamer-renoveren",
    title: "Badkamer renoveren",
    h1: "Badkamer renoveren van A tot Z",
    tag: "02 — Complete badkamers",
    image: "/brand/services-v2/complete-badkamer-v4.png",
    intro:
      "Uw droombadkamer verdient één aanspreekpunt. Master-Bathrooms verzorgt de volledige renovatie van uw badkamer — van ontwerp tot oplevering, inclusief tegelwerk, sanitair, verlichting en vloerverwarming.",
    sections: [
      {
        h: "Compleet ontzorgd",
        p: "Wij regelen alle vakmensen, materialen en planning. U hoeft niet meer met verschillende partijen te bellen — één team, één contactpersoon, één eindverantwoordelijke voor het gehele resultaat.",
      },
      {
        h: "Ontwerp & advies",
        p: "Tijdens het gratis adviesgesprek bekijken we uw ruimte, wensen en budget. U ontvangt een helder ontwerpvoorstel met materiaalkeuze, indeling en eerlijke prijsopgave zonder verrassingen achteraf.",
      },
      {
        h: "Kwaliteit & garantie",
        p: "Wij werken uitsluitend met hoogwaardige merken en gecertificeerde materialen. Op ons werk én de geleverde materialen krijgt u standaard garantie, schriftelijk vastgelegd bij oplevering.",
      },
    ],
  },
  {
    slug: "toilet-renoveren",
    title: "Toilet renoveren",
    h1: "Toilet renoveren — modern, snel en netjes",
    tag: "03 — Toilet",
    image: "/brand/services-v2/toiletten-zakelijk-v6.png",
    intro:
      "Een gedateerd toilet transformeren tot een moderne, tijdloze ruimte kan sneller dan u denkt. Master-Bathrooms renoveert uw toilet inclusief tegelwerk, hangtoilet, wastafel en verlichting.",
    sections: [
      {
        h: "Wat we voor u doen",
        p: "Volledig strippen van uw huidige toilet, waterdichte ondergrond aanleggen, nieuwe tegels of wandpanelen plaatsen, hangtoilet installeren met inbouwreservoir, en afwerking met wastafel en verlichting.",
      },
      {
        h: "Materialen",
        p: "Grote naadloze wandpanelen (marmer-look, betonlook of natuurlijke steen), hangtoiletten van topmerken, opbouw of inbouw wastafelkranen in matzwart, chroom of geborsteld goud, en warmwitte spots of pendellamp.",
      },
      {
        h: "Doorlooptijd",
        p: "Een compleet toiletrenovatie leveren wij vaak binnen enkele werkdagen op. Tijdens de renovatie zorgen wij voor een schone werkruimte en dagelijkse oplevering.",
      },
    ],
  },
  {
    slug: "zakelijke-toiletrenovatie",
    title: "Zakelijke toiletrenovatie",
    h1: "Zakelijke toiletrenovatie — representatief en snel",
    tag: "04 — Zakelijk",
    image: "/brand/services-v2/toiletten-zakelijk-v6.png",
    intro:
      "Voor kantoorpanden, horeca en winkels renoveren wij toiletruimtes strak, duurzaam en met minimale downtime. Master-Bathrooms plant strak, communiceert helder en levert professioneel op.",
    sections: [
      {
        h: "Voor bedrijven",
        p: "Kantoren, restaurants, hotels, winkels en praktijken — wij begrijpen dat sluiting geld kost. Daarom werken wij met strakke planningen, vaak buiten openingstijden, met dagelijkse voortgangsrapportage.",
      },
      {
        h: "Duurzame materialen",
        p: "Wij gebruiken materialen die dagelijks intensief gebruik aankunnen: grote naadloze wandpanelen, robuuste hangtoiletten met sensor-spoeling, hygiënische tegels en anti-slip vloeren.",
      },
      {
        h: "Planning & oplevering",
        p: "Van kleine aanpassing tot volledige verbouwing van meerdere toiletruimtes. Wij leveren vaak binnen 1 tot 2 weken op — met garantie, schone oplevering en instructies voor het onderhoudsteam.",
      },
    ],
  },
];

export const getService = (slug) => SERVICES.find((s) => s.slug === slug);
